"use client"
import React, {useRef, useState} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {ChevronRight, ChevronLeft} from "lucide-react";
import Link from "next/link";
import Image from "next/image";

const ProductResult = ({data}: { data: any }) => {
    const prevRef = useRef<HTMLDivElement>(null);
    const nextRef = useRef<HTMLDivElement>(null);
    const swiperRef = useRef<any>(null);

    const [isBeginning, setIsBeginning] = useState(false);
    const [isEnd, setIsEnd] = useState(false);


    const resultProducts = data?.products;

    return (
        <>
            {resultProducts?.length > 0 ? (<div className="relative">
                {/* Left Navigation Button */}
                <div
                    ref={prevRef}
                    onClick={() => swiperRef.current?.slideNext()}
                    className={`absolute z-30 cursor-pointer w-6 h-6 border border-gray-500 rounded-full 
                 flex items-center justify-center p-0.5 transition-all ${
                        isBeginning ? "opacity-100" : "opacity-40 cursor-not-allowed"
                    }`}
                    style={{
                        left: "-10px",
                        top: "30px",
                    }}
                >
                    <ChevronLeft/>
                </div>

                {/* Swiper Component */}
                <Swiper
                    modules={[Navigation]}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                        if (prevRef.current && nextRef.current) {
                            swiper.params.navigation = {
                                prevEl: prevRef.current,
                                nextEl: nextRef.current,
                            };
                            swiper.navigation.init();
                            swiper.navigation.update();
                        }
                    }}
                    onSlideChange={(swiper) => {
                        setIsBeginning(swiper.isBeginning);
                        setIsEnd(swiper.isEnd);
                    }}
                    pagination={{clickable: true}}
                    slidesPerView={2}
                    spaceBetween={20}

                >
                    {resultProducts?.map((product: any, index: number) => (
                        <SwiperSlide
                            key={index}
                            className={"w-[190px] h-[200px]"}
                        >
                            <Link href={`/product/${product.unique_id}/${product.slug}`}
                                  target={`_blank`}
                                  className="flex items-center gap-2  border p-2 rounded-2xl hover:shadow mb-2 transition-all"
                            >
                                <Image
                                    src={product?.image}
                                    alt={product.title}
                                    width={70}
                                    height={86}
                                    className="object-cover rounded-lg mb-2 w-[70px] h-[86px]"
                                />
                                <p className="text-sm font-medium line-clamp-3">{product?.title}</p>
                            </Link>
                        </SwiperSlide>
                    ))
                    }
                </Swiper>

                {/* Right Navigation Button */
                }
                <div
                    ref={nextRef}
                    onClick={() => swiperRef.current?.slidePrev()}
                    className={`absolute z-30 cursor-pointer w-6 h-6 border border-gray-500 rounded-full 
                 flex items-center justify-center p-0.5 transition-all ${
                        isEnd ? "opacity-100" : "opacity-40 cursor-not-allowed"
                    }`}
                    style={{
                        right: "-12px",
                        top: "30px",
                    }}
                >
                    <ChevronRight/>
                </div>
            </div>) : <div className={"flex flex-col min-h-24 items-center justify-center"}>محصولی یافت نشد</div>}


        </>
    )
        ;
};

export default ProductResult;
